import { FB_NAMESPACE } from './constants';
export const getFacebookAccessToken = (state) => state[FB_NAMESPACE].accessToken;
export const getIsLoadingSdk = (state) => state[FB_NAMESPACE].loadingSdk;
export const getIsFetchingToken = (state) => state[FB_NAMESPACE].fetchingToken;
export const getProvidedNewEmailByFacebookUser = (state) => state[FB_NAMESPACE].passwordResetEmail;
export const getFacebookFormErrors = (state) => state[FB_NAMESPACE].errors;
//# sourceMappingURL=selectors.js.map